import styled from 'styled-components';


const StyledStats = styled.div`
  max-width: 1200px;
  width: calc(95vw - 28px);
  background: white;
  padding: 14px;

  @media (max-width: 992px) {
    width: calc(95vw - 28px);
  }
`;

export default StyledStats;
